module.exports = __webpack_public_path__ + "img/coreintercomDesk.1f83fde6.png";